import { memo } from 'react';

export type SiteContext = 'marketing' | 'ai-amp';

interface BrandLogoProps {
  variant?: 'light' | 'dark';
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  site?: SiteContext;
  showSiteBadge?: boolean;
}

const sizeMap = {
  sm: { height: '24px' },
  md: { height: '32px' },
  lg: { height: '48px' },
};

/**
 * Unified brand logo with optional site indicator badge
 */
function BrandLogoComponent({
  variant = 'light',
  className = '',
  size = 'md',
  site,
  showSiteBadge = false,
}: BrandLogoProps) {
  const { height } = sizeMap[size];
  const mutedColor = variant === 'light' ? 'text-white/50' : 'text-ink/50';
  
  const badgeColors = site === 'ai-amp' 
    ? 'bg-[#00D4FF]/10 text-[#00D4FF] border-[#00D4FF]/30'
    : 'bg-[#FF6B6B]/10 text-[#FF6B6B] border-[#FF6B6B]/30';

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <div className="flex items-center gap-1" aria-label="lykbl™">
        <img
          src="/lykbl_logo.png"
          alt="lykbl"
          style={{
            height,
            width: 'auto',
            filter: variant === 'dark' ? 'invert(1) hue-rotate(180deg)' : 'none',
            objectFit: 'contain',
          }}
          className="select-none"
        />
        <sup className={`text-[8px] font-medium ${mutedColor}`} style={{ marginTop: '-8px' }}>
          ™
        </sup>
      </div>
      
      {showSiteBadge && site && (
        <span className={`text-[10px] font-medium px-2 py-0.5 rounded-full border ${badgeColors}`}>
          {site === 'ai-amp' ? 'Ai-AMP' : 'lykbl.com'}
        </span>
      )}
    </div>
  );
}

export const BrandLogo = memo(BrandLogoComponent);
